import { Container, Graphics } from 'pixi.js';

interface Snowflake {
  graphics: Graphics;
  x: number;
  y: number;
  speed: number;
  drift: number;
  size: number;
}

export class SnowEffect extends Container {
  private snowflakes: Snowflake[] = [];
  private gameWidth: number;
  private gameHeight: number;
  private groundY: number;
  private snowflakeCount = 25;

  constructor(gameWidth: number, gameHeight: number, groundY: number) {
    super();

    this.gameWidth = gameWidth;
    this.gameHeight = gameHeight;
    this.groundY = groundY;

    this.createSnowflakes();
  }

  private createSnowflakes(): void {
    for (let i = 0; i < this.snowflakeCount; i++) {
      const size = Math.random() * 1.5 + 0.5;
      const x = Math.random() * this.gameWidth;
      const y = Math.random() * this.gameHeight;
      const speed = Math.random() * 15 + 10;
      const drift = (Math.random() - 0.5) * 10;

      const graphics = new Graphics();
      graphics.circle(0, 0, size);
      graphics.fill({ color: 0xffffff, alpha: 0.25 });

      graphics.x = x;
      graphics.y = y;

      this.addChild(graphics);

      this.snowflakes.push({
        graphics,
        x,
        y,
        speed,
        drift,
        size,
      });
    }
  }

  update(deltaTime: number): void {
    for (const snowflake of this.snowflakes) {
      snowflake.y += snowflake.speed * deltaTime;
      snowflake.x += snowflake.drift * deltaTime;

      if (snowflake.y > this.groundY) {
        snowflake.y = -10;
        snowflake.x = Math.random() * this.gameWidth;
      }

      if (snowflake.x < -10) {
        snowflake.x = this.gameWidth + 10;
      } else if (snowflake.x > this.gameWidth + 10) {
        snowflake.x = -10;
      }

      snowflake.graphics.x = snowflake.x;
      snowflake.graphics.y = snowflake.y;
    }
  }

  updateDimensions(gameWidth: number, gameHeight: number, groundY: number): void {
    this.gameWidth = gameWidth;
    this.gameHeight = gameHeight;
    this.groundY = groundY;

    for (const snowflake of this.snowflakes) {
      if (snowflake.x > gameWidth) {
        snowflake.x = Math.random() * gameWidth;
      }
    }
  }
}
